import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { addMoveInFilter, removeMoveInFilter, fetchSearchResultsIfNotBusy } from '../actions/search'
import { translate } from '../../modules/helper-functions'
import Toggle from './Toggle'

const Container = styled.div`
  width: 100%;
  padding-top: 25px;
  font-size: 14px;
`

/**
 * MoveInFilter component
 */
class MoveInFilter extends Component {
  /**
   * @constructor
   * @param {any} props
   */
  constructor( props ) {
    super( props )

    this.handleChange = this.handleChange.bind( this )
  }

  /**
   * Function handles the component changes by
   * either adding or removing the Move In filter.
   *
   */
  handleChange() {
    const { addFilter, removeFilter, moveIn } = this.props
    if ( moveIn ) {
      removeFilter()
    } else {
      addFilter()
    }
  }

  /**
   * Render method.
   */
  render() {
    const { translations, moveIn } = this.props
    return (
      <Container>
        <Toggle
          id={'moveInFilter'}
          handleChange={this.handleChange}
          checked={moveIn}
          label={translate( translations, 'Only Move In spaces' )}
          />
      </Container>
    )
  }
}

MoveInFilter.propTypes = {
  addFilter: PropTypes.func.isRequired,
  removeFilter: PropTypes.func.isRequired,
  translations: PropTypes.object.isRequired,
  moveIn: PropTypes.bool.isRequired
}

/**
 * Add dispatch functions to components props.
 *
 * @param {function} dispatch
 * @return {object}
 */
const mapDispatchToProps = ( dispatch ) => {
  return {
    addFilter: () => {
      dispatch( addMoveInFilter())
      dispatch( fetchSearchResultsIfNotBusy())
    },
    removeFilter: () => {
      dispatch( removeMoveInFilter())
      dispatch( fetchSearchResultsIfNotBusy())
    }
  }
}

/**
 * Map the redux state to component props.
 *
 * @return {object}
 */
const mapStateToProps = ( state ) => ({
  translations: state.translations,
  moveIn: Boolean( state.search.filters.movein )
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)( MoveInFilter )
